{
  "it": {
    "signature": {
      "actions": {
        "clearSignature": "Svuota firma",
        "edit": "Modifica",
        "open_and_read": "Apri e leggi",
        "request": "Richiedi firma",
        "save": "Salva",
        "sign": "Firma"
      },
      "labels": {
        "add": "Aggiungi",
        "add_customer_signatures": "Deve aggiungere le firme dei clienti prima di salvare.",
        "add_team_member_signatures": "Deve aggiungere le firme dei membri del team prima di salvare.",
        "all_customers_signed": "Tutti gli acquirenti richiesti hanno già firmato. I documenti devono ancora essere firmati dai rappresentanti di {client_name} e la proposta verrà approvata una volta firmati. Non è richiesta alcuna ulteriore azione da parte Sua.",
        "browserNotSupported": "Abbiamo rilevato che il Suo browser mobile potrebbe non supportare le firme elettroniche. Se riscontra problemi, cambi browser o dispositivo, oppure carichi un documento già firmato.",
        "customer_signatories": "Firmatari clienti",
        "customers_left_to_sign": "1 cliente deve firmare | {customers_left_to_sign} clienti devono firmare",
        "customers_required_to_sign": "1 acquirente in più deve firmare i documenti. | {customers_left_to_sign} acquirenti in più devono firmare i documenti.",
        "customers_signed_names": "Clienti che hanno già firmato: {names}",
        "document_image_data_error": "Impossibile caricare i dati immagine del documento.",
        "document_load_error": "Impossibile caricare il documento. Verifichi che il file sia valido.",
        "document_url_missing_error": "URL del documento mancante.",
        "documents_to_sign": "Documenti da firmare",
        "draw_signature": "Disegni la Sua firma qui sotto",
        "employee_signatories": "Firmatari {client_name}",
        "employees_signed_names": "Membri del team che hanno già firmato: {names}",
        "empty_signature_warning": "Disegni prima la Sua firma.",
        "marked": "Posizione della firma contrassegnata",
        "next": "Avanti",
        "no_signature_indicators_warning": "Indichi dove il documento deve essere firmato, facendo clic sulla pagina o sulle pagine.",
        "ok": "OK",
        "original": "Originale",
        "page": "pagina",
        "place_signature_subtitle": "Faccia clic sulla pagina o sulle pagine in cui è necessario che il cliente firmi elettronicamente",
        "place_signature_title": "Contrassegna dove firmare",
        "read_and_sign": "Ho letto e desidero firmare",
        "remove": "Rimuovi",
        "requesting_signage": "Richiesta firma a",
        "save_error": "Si è verificato un errore durante il salvataggio.",
        "sign": "Firma",
        "sign_steps": "Due passaggi: legga ogni documento, poi firmi qui sotto.",
        "signatories_for_all_documents": "Il numero di firmatari si applica a tutti i documenti. Modificandolo verranno rimosse tutte le firme e dovrà aggiungerle di nuovo.",
        "signatureNotPossible": "Le firme elettroniche non sono disponibili per questo tipo di file",
        "signatureNotPossibleSize": "Le firme elettroniche non sono disponibili per file superiori a 40 MB",
        "signatures_pending_from_client": "Firme in attesa dal team di {client_name}",
        "signed": "Firmato",
        "signed_progress": "Firmati: {already_signed_count} su {all_required_to_sign_count}",
        "signing_applies_to_all": "La firma vale per tutti i documenti qui sopra. È giuridicamente vincolante.",
        "specifyWhereToSign": "Contrassegna dove firmare",
        "step_read_documents": "Legga i documenti",
        "team_member": "Membro del team",
        "team_member_signature_warning": "Potrà richiedere la firma ai membri del team dopo aver richiesto la firma ai clienti.",
        "thank_you_for_signing": "Grazie per aver firmato.",
        "toBeSigned": "Da firmare",
        "troubleSigningUpload": "Problemi a firmare? Carichi un documento già firmato"
      }
    }
  }
}
